import { createContext } from "react";
export const FiveQuestionsContext = createContext();
